<!-- {{user|json}} -->
<div class="btn-float">
	<i class="bi bi-file-earmark-plus-fill"></i>
</div>
<div class="dashboard-card list-card">
	<div class="widget-header">
		<h5>
			Users List
		</h5>

		<nav class="d-flex gap-2" *ngIf="user.user_role[0].code=='spr'">
			<button class="chip" (click)="urType=''">
				<i class="bi bi-people-fill"></i>
				<span>All at Once</span>
			</button>
			<button class="chip" (click)="urType='T'">
				<i class="bi bi-person-check-fill"></i>
				<span>Trial Users</span>
			</button>
			<button class="chip" (click)="urType='K'">
				<i class="bi bi-person-lines-fill"></i>
				<span>KYC Details</span>
			</button>
			<button class="chip" (click)="urType='P'">
				<i class="bi bi-person-fill-check"></i>
				<span>Subscribers</span>
			</button>
		</nav>

		<div class="d-flex gap-3">
			<button class="btn btn-sm btn-outline-primary py-0" data-bs-toggle="modal" data-bs-target="#staticBackdrop3" 
				(click)="orgConnect()" *ngIf="!user.erp_key && user.user_role[0].code=='spr'">
				Org. Connect
			</button>

			<button class="btn btn-sm btn-light py-0" data-bs-toggle="modal" data-bs-target="#frmBackdrop" (click)="newClick()">
				+Add New
			</button>
		</div>
	</div>

	<div class="w-100">
		<table id="orgTable" class="table table-striped w-100">
			<thead>
				<tr>
					<th>#</th>
					<th>Name / Institute</th>
					<th>Username</th>
					<th>Role</th>
					<th>Reg. Date</th>
					<th>Active?</th>
					<th style="text-align: end;">Action</th>
				</tr>
			</thead>
			<tbody *ngIf="allData && allData.length">
				<!-- if(urType=='' || (urType=='T' && data.for_trial && !data.kyc_data) || (urType=='P'
				&& !data.for_trial) || (urType=='K' && data.kyc_data)) -->
				@for(data of allData; track $index; let idx = $index;) {
				<ng-container *ngIf="(urType=='' || 
					(urType=='T' && data.source_schema && data.source_schema.substr(0,2)!='x_') || 
					(urType=='K' && data.source_schema && data.source_schema.substr(0,2)!='x_' && data.institute) ||
					(urType=='P' && data.source_schema && data.source_schema.substr(0,2)=='x_')
				)">
				<tr>
					<td>{{idx+1}}.</td>
					<td *ngIf="!data.inst_name">
						<b class="fw-medium">{{data.display_name}}</b>
					</td>
					<td *ngIf="user.user_role[0].code=='spr' && data.inst_name">
						<b class="fw-medium">{{data.inst_name}}</b>
						<small [class.text-danger]="(data.source_schema && data.source_schema.substr(0,2)=='x_')">
							<br>[ ERP Key: {{data.erp_key}} ]
						</small>
					</td>
					<td>{{data.user_name}}
						<!-- <small *ngIf="user.user_role[0].code=='spr' && data.inst_name"><br>({{data.display_name}})</small> -->
					</td>
					<td>
					@if(data.user_role.length>0){
						@for(r of data.user_role; track $index;) {
						<div>{{r.name}}</div>
						}
					} @else {
						<div>{{data.user_role.name}}</div>
					}
					</td>
					<td>{{data?.cur_date?.substr(0,10)}}</td>
					<td>{{data.is_active}}</td>
					<td>
						<div class="d-flex gap-2 justify-content-end" *ngIf="data.cur_date">
							<span style="cursor: pointer;" (click)="viewClick(data)" title="View KYC Details"
								*ngIf="user.user_role[0].code=='spr' && (data.source_schema && data.source_schema.substr(0,2)!='x_') && 
								data.institute" data-bs-toggle="modal" data-bs-target="#staticBackdrop2">
								<i class="bi bi-window-stack"></i>
							</span>

							@if((!data.source_schema && (data.user_role[0].code != 'adm' || data.display_name != 'Administrator')) || 
								(data.source_schema && data.source_schema.substr(0,2)!='x_')) {
								<span style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#frmBackdrop"
									(click)="editClick(data)" title="Modify">
									<i class="bi bi-pencil-square text-success"></i>
								</span>
								<span style="cursor: pointer;" (click)="deleteClick(data)" title="Delete">
									<i class="bi bi-trash3 text-danger"></i>
								</span>
							} @else {
								<span>
									<i class="bi bi-pencil-square text-secondary"></i>
								</span>
								<span>
									<i class="bi bi-trash3 text-secondary"></i>
								</span>
							}

						</div>
						<!-- {{data|json}} -->
					</td>
				</tr>
				</ng-container>
				}
			</tbody>
		</table>

		<div class="text-danger" align="center" *ngIf="allData && !allData.length && !loading">
			<i class="bi bi-x-circle"></i> No data available.
		</div>
	</div>
</div>

<div class="modal fade" id="frmBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="frmBackdropLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="frmBackdropLabel">Add New User</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body" style="min-height: 400px; overflow: visible !important;">
				<app-user-form [user]="user" [action]="btnClick" style="overflow: visible !important;"></app-user-form>
			</div>
			<div class="modal-footer">
				<button type="button" class="col-2 btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancel</button>
				<button type="button" class="col-2 btn btn-sm btn-primary" data-bs-dismiss="modal"
					(click)="btnClick = isEdit ? 'update' : 'save'; reloadData();">
					{{isEdit ? 'Update' : 'Save'}}
				</button>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" id="staticBackdrop2" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="staticBackdropLabel2" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl kyc-body" *ngIf="user && user.user_role[0].code=='spr'">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalToggleLabel">KYC Details View: {{selUser?.display_name}}</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
					*ngIf="!dataService.onBoarding"></button>
			</div>
			<div class="modal-body" style="height: 92vh;">
				<app-view-kyc [user]="selUser"></app-view-kyc>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" id="staticBackdrop3" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="staticBackdropLabel3" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl kyc-body" *ngIf="selOrg && user && user.user_role[0].code=='spr'">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalToggleLabel">Institutes View: {{selOrg?.org_name}}</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body" style="height: 92vh;">
				<app-org-view [org]="selOrg"></app-org-view>
			</div>
		</div>
	</div>
</div>
